
/**
 * Extends a line formed by 2 points.
 * @param {number} x1 The x coordinate of the first point.
 * @param {number} y1 The y coordinate of the first point.
 * @param {number} x2 The x coordinate of the second point.
 * @param {number} y2 The y coordinate of the second point.
 * @param {number} distance The distance to extend the line to.
 * @returns {[number, number]} The coordinate of the extended line from the first point.
 */
export function extendLine(x2, y2, x1, y1, distance){
  return [
    x1 + distance * (x2 - x1),
    y1 + distance * (y2 - y1) 
  ]
}